/**
 * ENR-1641 system email template editor.
 * Pulled from production until the editor is reinvented as a simpler UI.
 * Still available on local / development / staging for rebuild work.
 */

const PRODUCTION_HOSTS = new Set([
  'enrollio-portal.uc.r.appspot.com',
  'studio.enrollio.ai',
  'app.enrollio.ai',
  'www.app.enrollio.ai',
]);

export function isQaDeployHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') {
    return true;
  }
  return (
    host.includes('-staging') ||
    host.includes('portal-staging') ||
    host.includes('-dev') ||
    host.includes('development')
  );
}

export function resolveSystemEmailTemplateEditorEnabled(input: {
  sentryEnv: string;
  hostname?: string;
}): boolean {
  const host = (input.hostname || '').toLowerCase();
  if (host && PRODUCTION_HOSTS.has(host)) {
    return false;
  }
  if (host && isQaDeployHost(host)) {
    return true;
  }
  return (input.sentryEnv || '').toLowerCase() !== 'production';
}

export const SYSTEM_EMAIL_TEMPLATE_EDITOR_ENABLED =
  resolveSystemEmailTemplateEditorEnabled({
    sentryEnv: import.meta.env.VITE_SENTRY_ENV || '',
    hostname: typeof window !== 'undefined' ? window.location.hostname : '',
  });
